import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Search } from 'lucide-react';
import { useCraftingLog } from '../hooks/useCraftingLog';
import { CraftingLogTable } from '../components/CraftingLogTable';
import { RECIPE_TYPE_OPTIONS } from '../constants';

const RECIPE_TYPES = [{ value: 'all', label: 'All Types' }, ...RECIPE_TYPE_OPTIONS] as const;

export function CraftingLogPage() {
  const [userId, setUserId] = useState('');
  const [searchUserId, setSearchUserId] = useState('');
  const [typeFilter, setTypeFilter] = useState('all');

  const { entries, loading, error, hasMore, loadMore } = useCraftingLog({
    userId: searchUserId || undefined,
    type: typeFilter !== 'all' ? typeFilter : undefined,
    admin: true,
  });

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchUserId(userId);
  };

  return (
    <div className="max-w-6xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-semibold">Crafting Log</h1>

      <div className="flex gap-3">
        <form onSubmit={handleSearch} className="flex gap-2 flex-1 max-w-md">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Filter by user ID..."
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              className="pl-9"
              aria-label="Filter by user ID"
            />
          </div>
          <Button type="submit" variant="secondary">
            Search
          </Button>
        </form>

        <Select value={typeFilter} onValueChange={setTypeFilter}>
          <SelectTrigger className="w-[160px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {RECIPE_TYPES.map((t) => (
              <SelectItem key={t.value} value={t.value}>
                {t.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {error && <p className="text-sm text-destructive">{error}</p>}

      <CraftingLogTable
        entries={entries}
        loading={loading}
        hasMore={hasMore}
        onLoadMore={loadMore}
      />
    </div>
  );
}
